import React, { type ChangeEvent, type FocusEvent, type ReactNode } from 'react'
import cn from 'classnames'
import { InputFieldType } from '../../../types/InputFieldType'

interface FormFieldProps {
  label?: string
  icon?: React.ForwardRefExoticComponent<React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>>
  minDate?: string
  placeholder?: string
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  onBlur: (e: FocusEvent<HTMLInputElement>) => void
  showError?: boolean
  errorMessage?: string
  children?: ReactNode
  inputType?: InputFieldType
  id?: string
}

export const StandardIconInput: React.FC<FormFieldProps> = ({
  inputType = InputFieldType.Text,
  icon,
  label,
  minDate,
  placeholder,
  value,
  onChange,
  onBlur,
  showError,
  errorMessage,
  children,
  id
}) => {
  const Icon = icon

  return (
    <div className="flex flex-col w-full">
      <label>{label}</label>

      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-4 pr-16  flex items-center pointer-events-none">
            {/* @ts-expect-error */}
            <Icon className="h-5 w-5 text-gray-400 pr-16" aria-hidden="true" />
          </div>
        )}

        <input
          id={id}
          min={minDate}
          type={inputType}
          className={cn('py-2 text-left w-full h-full border rounded-md', showError ? 'border-red-500' : ' border-wpy-gray', icon ? 'pl-12' : 'pl-6')}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        />
        {showError && <div className="absolute left-0.5 top-1 text-lg text-red-500">❗</div>}
      </div>
      <div className="h-6 text-sm text-red-500">{errorMessage}</div>
      {children}
    </div>
  )
}
